import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Status from '../../../enums/Status';
import {getSiteId, isNewGuestUpdatedPage} from '../../../v2/selectors/selectors';
import useStyles from './CreateAccount.styles';
import CreateAccountForm from './CreateAccountForm/CreateAccountForm';
import CreateAccountPending from './CreateAccountPending/CreateAccountPending';
import LoginNewAccount from './LoginNewAccount';
import VerifyAccount from './VerifyAccount/VerifyAccount';

export function CreateAccount(props) {
  const classes = useStyles({...props});
  
  const renderContents = () => {
    switch (props.status) {
      case Status.LOADING:
        return <CreateAccountPending />;
      case Status.SUCCESS:
        return <VerifyAccount />;
      case Status.VERIFICATION_SUCCESS:
        return <LoginNewAccount />;
      default: // todo ask UX about errors - maybe show an error here or what?
        return <CreateAccountForm />;
    }
  };
  
  return (
    <div className={classes.createAccount} data-test="CreateAccount">
      {renderContents()}
    </div>
  );
}

CreateAccount.propTypes = {
  status: PropTypes.string.isRequired,
  isNewGuestUpdatedPage: PropTypes.bool.isRequired,
  siteId: PropTypes.bool,
};

const mapStateToProps = state => ({
  status: state.createAccount.status,
  isNewGuestUpdatedPage: isNewGuestUpdatedPage(state),
  siteId: getSiteId(state) === 95 || getSiteId(state) === 83 || getSiteId(state) === 208,
});

export default connect(mapStateToProps)(CreateAccount);
